<template>
  <div class="rot-page-main">
    <Menus :menu="menuItems" @menuClicked="menuClicked" />
    <div class="right-container">
      <div class="filter-area">
        <div>{{ filterText }}</div>
        <ButtonFilter
          class="button-filter"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
        >
          <div class="filter-item">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="dateFilterChecked"
            >
              <div class="dates">
                <DateTimePicker
                  style="margin-right: 5px"
                  placeholder="From"
                  :isDisabled="!dateFilterChecked"
                  :showTime="false"
                  :value.sync="startDate"
                />
                <DateTimePicker
                  style="margin-left: 5px; margin-right: 5px"
                  :isDisabled="!dateFilterChecked"
                  placeholder="To"
                  :showTime="false"
                  :value.sync="endDate"
                />
              </div>
            </BoxContainer>
          </div>
          <div class="filter-item">
            <BoxContainer
              title="Search"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="searchFilterChecked"
            >
              <Dropdown
                placeholder="Search By"
                :items="searchFilterItems"
                itemKey="Search Criteria"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedSearchBy"
                :errorMessage.sync="searchByError"
                @selected="searchBySelected"
                validator="text,40"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :isDisabled="!searchFilterChecked || criteriaDisabled"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedCriteria"
                validator="text,40"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchByValue"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :errorMessage.sync="searchByValueError"
              />
            </BoxContainer>
          </div>
          <button @click="refreshClicked" :disabled="!dateFilterChecked && !searchFilterChecked">Refresh</button>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="tabulator-area">
        <TableBox
          title="ROT Lists"
          :tableData="rotList"
          :selectedRow.sync="selectedROT"
          :maxSelection="1"
          :additionalIconsIndex="[0]"
          :dataType="{
            'ROT Date Time': 'datetime',
            'Haul Accept Time': 'datetime',
            'Required Time': 'datetime',
            'Last Update': 'datetime',
            'Total Cont': 'number',
            'Print Ct': 'number',
          }"
        />
      </div>
    </div>
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      :disabledSave="popupEntryDisabledSave"
      :createdBy="popupEntryCreatedBy"
      :updatedBy="popupEntryUpdatedBy"
      :successMessages="popupEntrySuccessMessage"
      :messages="popupEntryMessages"
      :errorMessages="popupEntryErrorMessage"
      :requiredError="popupEntryRequiredError"
      @requiredClicked="popupRequiredClicked"
      :viewMode="popupEntryViewMode"
      :cancelButton="popupEntryViewMode ? 'Close' : 'Cancel'"
      @save="saveClicked()"
    >
      <!-- <div v-if="popupEntryTitle == 'Select Job'" class="select-job-main">
        <div class="job-no-section">
          <Input placeholder="Job No" :inputValue.sync="jobNoInput" :errorMessage.sync="jobNoInputError" />
          <button @click="jobNoNextClicked">Next</button>
        </div>
        <div class="job-refresh-section">
          <DateTimePicker placeholder="Job Start Date" :value.sync="jobStartDate" :showTime="false" />
          <DateTimePicker placeholder="Job End Date" :value.sync="jobEndDate" :showTime="false" />
          <button @click="refreshJobListClicked">Refresh Job List</button>
        </div>
        <TableBox class="job-list-table" :tableData="jobList" :maxSelection="0" title="Jobs List" :additionalButtons="[{ text: 'Select', index: 0, width: 75 }]"
          @buttonClicked="jobListTableSelect" :stickColumn="[0]" :hideColumns="['Count', 'Imp/Exp']" :dataType="{'Job Date': 'date', 'Closing Date': 'date', 'ETA Date': 'date', 'Total Containers': 'number', 'Total Balance': 'number'}" />
      </div> -->
      <div class="new-rot-main">
        <div class="top-section">
          <div class="top-inputs">
            <div v-if="popupEntryTitle[0] == 'N' && selectedJob == null" style="display: flex; flex-direction: row">
              <DateTimePicker
                placeholder="Start"
                :showTime="false"
                :value.sync="jobStartDate"
                style="margin-right: 6px"
              />
              <DateTimePicker placeholder="End" :showTime="false" :value.sync="jobEndDate" style="margin-right: 6px" />
              <button style="margin-right: 6px" @click="refreshJobListClicked">Refresh</button>
            </div>
            <div class="flex-row">
              <InputQuery
                v-if="popupEntryTitle[0] == 'N'"
                placeholder="Job #"
                :isDisabled="popupEntryTitle[0] == 'N' && selectedJob != null"
                :items="jobList"
                :selectedObject.sync="selectedJob"
                itemKey="Job #"
                :showDesc="false"
                ref="jobNo"
                @selected="jobListTableSelect"
                validator="text,25"
              />
              <Input v-else placeholder="Job Type" :isDisabled="true" :inputValue.sync="JobNo" />
              <Input placeholder="Job Type" :isDisabled="true" :inputValue.sync="jobType" />
            </div>
            <Input placeholder="ROT No" :inputValue.sync="rotNo" :isDisabled="true" />
            <div class="flex-row">
              <DateTimePicker
                placeholder="ROT Date/Time"
                :value.sync="rotDateTime"
                :isDisabled="disableBillingFields"
              />
              <CheckBox title="Urgent" :isChecked.sync="isUrgent" :isDisabled="disableUrgent" />
            </div>
            <Input placeholder="Customer Code" :isDisabled="true" :inputValue.sync="customerCode" />
            <Input placeholder="Customer Name" :isDisabled="true" :inputValue.sync="customerName" />
            <InputQuery
              placeholder="Haul Bill To"
              :isRequired="true"
              :items="haulBillToList"
              :selectedObject.sync="selectedHaulBillTo"
              itemKey="BillTo"
              descKey="BillToName"
              :isDisabled="disableBillingFields"
              validator="text,115"
            />
          </div>
          <div class="top-inputs">
            <InputQuery
              placeholder="Haulier"
              :isRequired="true"
              :items="haulierList"
              :selectedObject.sync="selectedHaulier"
              itemKey="Code - Description"
              descKey="Description"
              ref="rotHaulier"
              :errorMessage.sync="rotHaulierError"
              :isDisabled="popupEntryViewMode"
              validator="text,115"
            />
            <Input placeholder="Haul Rqt No" :isDisabled="true" :inputValue.sync="haulRqtNo" />
            <Input placeholder="Haul Accept Time" :isDisabled="true" :inputValue.sync="haulAcceptTime" />
            <!-- <Input placeholder="Requested By" :isRequired="true" :errorMessage.sync="rotRequestByError" :isDisabled="popupEntryViewMode" ref="rotRequestBy"
              :inputValue.sync="requestedBy" /> -->
            <InputQuery
              placeholder="Requested By"
              :isRequired="true"
              :items="requestedByList"
              :selectedObject.sync="selectedRequestedBy"
              itemKey="EmployeeID"
              descKey="Employee Name"
              ref="rotRequestBy"
              :errorMessage.sync="rotRequestByError"
              :isDisabled="popupEntryViewMode"
              :allowFreeText="true"
              :search.sync="RequestedByValue"
              validator="text,10"
            />
            <Input
              placeholder="Rqt Accepted By"
              :inputValue.sync="rqtAcceptedBy"
              :isDisabled="popupEntryViewMode"
              :regex="{ regex: /^.{0,20}/, live: true }"
            />
          </div>
          <div class="top-print">
            <div class="indicator">{{ rotIndicator }}</div>
            <div class="spacer"></div>
            <div class="CMR">
              <img src="https://dsmlib.logistics.systems/Icons/Print.png" alt="" />
              <div>CMR: {{ rotPrintCount }}</div>
            </div>
          </div>
        </div>
        <div class="tab-section">
          <Tab :tabs="tabsItems" :tabIndex.sync="currentTabIndex">
            <!-- #region Location Info Tab -->
            <div slot="Location Info" class="flex-row tab-slot">
              <!-- #region First Column -->
              <div>
                <InputQuery
                  placeholder="Pick Up"
                  :isRequired="true"
                  :items="pickupList"
                  :selectedObject.sync="selectedPickup"
                  itemKey="Code - Company"
                  descKey="Company"
                  ref="rotPickup"
                  :errorMessage.sync="rotPickupError"
                  :isDisabled="popupEntryViewMode"
                  :canRefresh="true"
                  @refreshClicked="pickupInputQueryRefreshClicked"
                  validator="text,115"
                />
                <div class="flex-row">
                  <InputQuery
                    placeholder="Send To"
                    :isRequired="true"
                    :items="sendToList"
                    :selectedObject.sync="selectedSendTo"
                    itemKey="Code - Company"
                    descKey="Company"
                    ref="rotSendTo"
                    :errorMessage.sync="rotSendToError"
                    :isDisabled="disableBillingFields"
                    :canRefresh="true"
                    @refreshClicked="sendToInputQueryRefreshClicked"
                    validator="text,115"
                  />
                  <CheckBox
                    title="Show All"
                    style="white-space: nowrap"
                    :isChecked.sync="showAllSendTo"
                    :isDisabled="popupEntryTitle[0] == 'E' || popupEntryViewMode || disableShowAll"
                  />
                </div>
                <Input :inputValue.sync="tariffArea" placeholder="Tariff Area" :isRequired="true" :isDisabled="true" />
                <div class="flex-row">
                  <Input placeholder="Post Code" :isDisabled="true" :inputValue.sync="postcode" />
                  <Input placeholder="Zone" :isDisabled="true" :inputValue.sync="zone" />
                </div>
                <div class="flex-row">
                  <Input placeholder="Attention" :isDisabled="true" :inputValue.sync="attention" />
                  <Input placeholder="Tel No" :isDisabled="true" :inputValue.sync="telNo" />
                </div>
                <RemarksBox title="Address" :freeText="true" :text.sync="address" :isDisabled="disableBillingFields" />
              </div>
              <!-- #endregion -->
              <!-- #region Middle Column -->
              <div>
                <InputQuery
                  placeholder="Drop Off"
                  :isRequired="true"
                  :items="dropoffList"
                  :selectedObject.sync="selectedDropoff"
                  itemKey="Code - Company"
                  descKey="Company"
                  ref="rotDropoff"
                  :errorMessage.sync="rotDropoffError"
                  :isDisabled="popupEntryViewMode"
                  :canRefresh="true"
                  @refreshClicked="dropoffInputQueryRefreshClicked"
                  validator="text,115"
                />
                <Dropdown
                  placeholder="Trip"
                  :isRequired="true"
                  :items="tripList"
                  :selectedObject.sync="selectedTrip"
                  itemKey="Trip"
                  ref="rotTrip"
                  :errorMessage.sync="rotTripError"
                  :isDisabled="popupEntryViewMode"
                  validator="text,1"
                />
              </div>
              <!-- #endregion -->
              <!-- #region Last Column -->
              <div>
                <div class="flex-row">
                  <DateTimePicker
                    placeholder="Required"
                    :value.sync="requiredDateTime"
                    :isDisabled="popupEntryViewMode"
                  />
                  <DateTimePicker placeholder="To" :value.sync="toDateTime" :isDisabled="popupEntryViewMode" />
                </div>
                <div class="flex-row">
                  <Input
                    placeholder="Required Date Desc"
                    :inputValue.sync="desc"
                    :isDisabled="popupEntryViewMode"
                    :regex="{ regex: /^.{0,20}/, live: true }"
                  />
                  <CheckBox
                    title="Office Hours"
                    style="white-space: nowrap"
                    :isChecked.sync="isOfficeHours"
                    :isDisabled="popupEntryViewMode"
                  />
                </div>
                <Input
                  placeholder="Ability to accept No of cont."
                  validator="integer,9"
                  :inputValue.sync="abilityAcceptCont"
                  :isDisabled="popupEntryViewMode"
                />
                <Input
                  placeholder="Time needed to unstuff / stuff (Hour)"
                  :inputValue.sync="timeStuffUnstuff"
                  :isDisabled="popupEntryViewMode"
                  validator="decimal,9,10"
                />
                <CheckBox
                  title="Offload at Premises"
                  :isChecked.sync="isOffloadAtPremises"
                  :isDisabled="popupEntryViewMode"
                />
              </div>
              <!-- #endregion -->
            </div>
            <!-- #endregion -->
            <!-- #region Container Info Tab -->
            <div slot="Container Info" class="flex-row tab-slot">
              <!-- #region Left section -->
              <div style="width: 60%">
                <div class="flex-row">
                  <CheckBox
                    title="Select from list of containers belonging to a job"
                    :isChecked.sync="isSelectFromList"
                    @checkBoxClicked="containerInfoCheckBoxClicked('select')"
                    :isDisabled="popupEntryTitle[0] == 'E' || popupEntryViewMode"
                  />
                  <CheckBox
                    title="Request by total No of Containers"
                    :isChecked.sync="isRequestByTotalContainers"
                    @checkBoxClicked="containerInfoCheckBoxClicked()"
                    :isDisabled="popupEntryTitle[0] == 'E' || popupEntryViewMode"
                  />
                </div>
                <div v-if="isSelectFromList && !popupEntryViewMode" style="margin: 5px 0">
                  <button @click="addContainerClicked">+</button>
                  <button style="margin-left: 5px" @click="deleteContainerClicked">-</button>
                </div>
                <div v-show="isSelectFromList" style="margin-top: 5px; height: 270px">
                  <TableBox
                    title="Container Lists"
                    :tableData="containerListWithoutDeleteTag"
                    :selectedRow.sync="selectedContainer"
                    :hideColumns="['tag']"
                  />
                </div>
                <div v-show="isRequestByTotalContainers" style="margin-top: 5px">
                  <Input
                    placeholder="No of Cont Required"
                    textType="number"
                    :inputValue.sync="containerCount"
                    :isRequired="true"
                    :errorMessage.sync="containerCountError"
                    ref="contCount"
                  />
                  <Dropdown
                    placeholder="Container Size"
                    :items="contSizeList"
                    :selectedObject.sync="selectedConSize"
                    itemKey="Size"
                    :isRequired="true"
                    :errorMessage.sync="selectedConSizeError"
                    ref="contSize"
                    validator="text,2"
                  />
                  <Dropdown
                    placeholder="Container Type"
                    :items="contTypeList"
                    :selectedObject.sync="selectedContType"
                    itemKey="combined"
                    :isRequired="true"
                    :errorMessage.sync="selectedContTypeError"
                    ref="contType"
                    validator="text,60"
                  />
                  <Dropdown
                    placeholder="Handling Type"
                    :items="contHdgList"
                    :selectedObject.sync="selectedHdg"
                    itemKey="combined"
                    :isRequired="true"
                    :errorMessage.sync="selectedHdgError"
                    ref="hdgType"
                    validator="text,5"
                  />
                  <Dropdown
                    placeholder="Delivery Type"
                    :items="contDeliveryList"
                    :selectedObject.sync="selectedDelivery"
                    itemKey="combined"
                    :isRequired="true"
                    :errorMessage.sync="selectedDeliveryError"
                    ref="deliveryType"
                    validator="text,5"
                  />
                </div>
              </div>
              <!-- #endregion -->
              <!-- #region Right section -->
              <div style="width: 40%">
                <Input placeholder="Temperature" :inputValue.sync="temperature" :isDisabled="popupEntryViewMode" />
                <Input
                  placeholder="M3"
                  :inputValue.sync="m3"
                  :isDisabled="popupEntryViewMode"
                  validator="positiveDecimal,5,2"
                />
                <Input
                  placeholder="Weight (KG)"
                  :inputValue.sync="weight"
                  :isDisabled="popupEntryViewMode"
                  validator="positiveDecimal,5,2"
                />
                <Input
                  placeholder="Height (M)"
                  :inputValue.sync="height"
                  :isDisabled="popupEntryViewMode"
                  validator="positiveDecimal,5,2"
                />
                <Input
                  placeholder="Cont. Operator"
                  :isRequired="true"
                  :inputValue.sync="contOperator"
                  ref="rotContOperator"
                  :errorMessage.sync="rotContOperatorError"
                  :isDisabled="popupEntryViewMode"
                  :regex="{ regex: /^.{0,10}/, live: true }"
                />
                <Input
                  placeholder="Cont. Line"
                  :inputValue.sync="contLine"
                  :isDisabled="popupEntryViewMode"
                  :regex="{ regex: /^.{0,10}/, live: true }"
                />
                <Input
                  placeholder="Commodity"
                  :isRequired="true"
                  :inputValue.sync="commodity"
                  ref="rotCommodity"
                  :errorMessage.sync="rotCommodityError"
                  :isDisabled="popupEntryViewMode"
                />
                <CheckBox title="Fumigation" :isChecked.sync="isFumigation" :isDisabled="popupEntryViewMode" />
                <div class="remarks-container">
                  <div class="remarks-box-container">
                    <RemarksBox :text.sync="remarks" :isDisabled="popupEntryViewMode" :maxLength="200" />
                  </div>
                  <button v-if="!popupEntryViewMode" @click="addDefaultRemarksClicked">+</button>
                </div>
              </div>
              <!-- #endregion -->
            </div>
            <!-- #endregion -->
            <!-- #region Attachments Tab -->
            <div slot="Attachments" class="tab-slot">
              <div v-if="!popupEntryViewMode" class="flex-row">
                <BoxContainer style="width: 100%">
                  <Input
                    textType="file"
                    placeholder="Browse"
                    @fileChanged="attachmentFileChanged"
                    :multiFile="true"
                    ref="attachmentFileInput"
                  />
                  <Input placeholder="Remarks" :inputValue.sync="attachRemarks" />
                  <button @click="addAttachmentClicked">Add Attachment</button>
                </BoxContainer>
                <BoxContainer style="width: 100%" class="box-container">
                  <button @click="selectDocumentFromJob">Select Document From Job</button>
                </BoxContainer>
              </div>
              <button
                v-if="!popupEntryViewMode"
                style="width: fit-content; margin: 5px 0"
                @click="removeAttachmentClicked"
                >Remove Attachments</button
              >
              <TableBox
                title="Attachments"
                :tableData="attachmentList"
                :selectedRow.sync="selectedAttachments"
                :maxSelection="-1"
                :hideColumns="['DocumentGUID', 'File Type', 'File Data']"
              />
            </div>
            <!-- #endregion -->
          </Tab>
        </div>
      </div>
    </PopupEntry>

    <PopupV2
      :show="showDefaultRemarks"
      @buttonClicked="defaultRemarksButtonClicked"
      title="Default Remarks List"
      width="53%"
      height="95%"
      :buttons="defaultRemarksButtons"
    >
      <div style="height: fit-content; overflow: unset">Please select default remarks from the list below. </div>
      <TableBox
        style="max-height: calc(100% - 233px)"
        :tableData="defaultRemarksList"
        emptyMessage="Please contact DSM team to configure default remarks."
        title="Remarks"
        :selectedRow.sync="selectedDefaultRemarks"
        :maxSelection="-1"
        :columnWidth="[40, 500]"
      />
    </PopupV2>

    <PopupV2
      :show="showJobContainers"
      @buttonClicked="jobContainerButtonClicked"
      width="53%"
      height="95%"
      title="Job Containers List"
      :buttons="jobContainerButtons"
    >
      <CheckBox
        style="align-self: center; height: fit-content"
        title="Show Containers without CMR Only"
        :isChecked.sync="showJobContWithoutCMR"
        @checkBoxClicked="filterJobContWithoutCMR"
      />
      <div style="height: fit-content; overflow: unset">Please select your container from the list below</div>
      <TableBox
        style="max-height: calc(100% - 233px)"
        :tableData="filteredJobContainerList"
        title="Available Containers"
        :selectedRow.sync="selectedJobContainer"
        :maxSelection="-1"
      />
    </PopupV2>

    <PopupV2
      :show="showJobDocuments"
      @buttonClicked="jobDocumentsButtonClicked"
      width="50%"
      height="95%"
      title="Job Documents List"
      :buttons="jobDocumentsButtons"
    >
      <div style="height: fit-content; overflow: unset">Please select your documents from the list below</div>
      <TableBox
        style="max-height: calc(100% - 220px)"
        :tableData="jobDocumentsList"
        title="Available Documents"
        :selectedRow.sync="selectedJobDocuments"
        :maxSelection="-1"
        :loading="jobDocumentsLoading"
        :hideColumns="['documentGUID', 'ID', 'fileAtt', 'filetype']"
      />
    </PopupV2>

    <PopupV2
      :show="showDeleteReason"
      @buttonClicked="confirmDeleteROTButtonClicked"
      title="Confirm Delete ROT"
      :buttons="[
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'gray', textColor: 'white' },
      ]"
    >
      <div style="white-space: pre-wrap">{{ deleteMessage }}</div>
      <RemarksBox style="height: 120px" :text.sync="deleteReason" :freeText="true" title="Delete Reason" />
    </PopupV2>

    <div v-if="showPrintPopup" class="print-popup">
      <div class="title">ROT</div>
      <DesignerV2
        :show.sync="showPrintPopup"
        :viewMode="true"
        :reportData="rotFullData"
        reportFolder="ROTForm"
        :reportFile="designerV2ReportFile"
        :canShare="true"
      />
      <!-- <Designer @cancel="showPrintPopup = false" :quickPrint="true" :form="`ROT_${rotFullData['Haulier Code']}.json`" :data="rotFullData" /> -->
    </div>

    <DocStatusUpdate
      :showPopup.sync="showContainerUpdate"
      defaultCategory="container"
      :jobno="containerUpdateJobNo"
      :editDetails="selectedROT"
      :title="`Update Container Status for Job # ${containerUpdateJobNo}`"
      :updateDetails="containerUpdateDetails"
    />
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    sendtoRefreshData: function () {
      let refreshData = {};
      if (this.showAllSendTo == true) {
        refreshData = { masterfile: 'sendto_all' };
      } else {
        refreshData = { masterfile: 'sendto', cu_number: this.customerCode };
      }

      return refreshData;
    },
    jobContainerButtons: function () {
      const buttons = [];
      if (this.selectedJobContainer.length > 0) {
        buttons.push({ text: `Confirm ${this.selectedJobContainer.length} Container(s)` });
      } else {
        buttons.push({ text: `Select All Container (Without CMR)` });
      }
      buttons.push({ text: 'Cancel', color: 'gray', textColor: 'white' });

      return buttons;
    },
    defaultRemarksButtons: function () {
      const buttons = [];
      if (this.selectedDefaultRemarks.length > 0) {
        buttons.push({ text: `Add ${this.selectedDefaultRemarks.length} Remark(s)` });
      } else {
        buttons.push({ text: `Add Remark` });
      }
      buttons.push({ text: 'Cancel', color: 'gray', textColor: 'white' });

      return buttons;
    },
    jobDocumentsButtons: function () {
      const buttons = [];
      if (this.selectedJobDocuments.length > 0) {
        buttons.push({ text: `Confirm ${this.selectedJobDocuments.length} Document(s)` });
      }
      buttons.push({ text: 'Cancel', color: 'gray', textColor: 'white' });

      return buttons;
    },
    designerV2ReportFile: function () {
      if (this.selectedROT.length <= 0) {
        return [];
      }
      return [`ROT_${this.selectedROT[0]['FormName']}.json`];
    },
    containerListWithoutDeleteTag: function () {
      return this.containerList.filter((container) => {
        return container['tag'] != '5';
      }); //remove delete tag
    },
  },
  data: function () {
    return {
      startDate: null,
      endDate: null,
      rotList: [],
      selectedROT: [],
      rotFullData: null,
      lastRefreshed: '',
      selectedJob: null,
      mainFilterIsOpen: false,
      showFilterBox: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      filterText: '',
      searchFilterItems: [],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedCriteria: null,
      selectedSearchBy: null,
      criteriaDisabled: false,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',

      menuItems: [
        { title: 'New ROT', icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png', enabled: false },
        { title: 'Edit ROT', icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png', enabled: false },
        { title: 'Delete ROT', icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png', enabled: false },
        { title: 'View ROT', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: false },
        { title: 'Print ROT', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false },
        { title: 'eROT', icon: 'https://dsmlib.logistics.systems/Icons/eROT.png' },
        {
          title: 'Update Cont. Status',
          icon: 'https://dsmlib.logistics.systems/Icons/UpdateContainerStatus.png',
          enabled: false,
        },
        { title: 'Print Notices', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false },
      ],

      //#region PopupEntry data
      popupEntryShow: false,
      popupEntryTitle: '',
      popupEntryDisabledSave: false,
      popupEntryCreatedBy: '',
      popupEntryUpdatedBy: '',

      popupEntryMessages: [],
      popupEntrySuccessMessage: [],
      popupEntryErrorMessage: [],
      popupEntryRequiredError: [],

      requiredErrorIndexMapping: [
        { key: 'rotHaulier', index: -1 },
        { key: 'rotRequestBy', index: -1 },
        { key: 'rotPickup', index: 0 },
        { key: 'rotSendTo', index: 0 },
        { key: 'rotDropoff', index: 0 },
        { key: 'rotTrip', index: 0 },
        { key: 'rotContOperator', index: 1 },
        { key: 'rotCommodity', index: 1 },
        { key: 'containerListing', index: 1 },
        { key: 'contCount', index: 1 },
        { key: 'contSize', index: 1 },
        { key: 'contType', index: 1 },
        { key: 'hdgType', index: 1 },
        { key: 'deliveryType', index: 1 },
      ],
      popupEntryViewMode: false,
      //#endregion

      //#region Job Selection Data
      jobNoInput: '',
      jobNoInputError: '',
      jobStartDate: null,
      jobEndDate: null,
      jobList: [],
      jobDetails: null,
      //#endregion

      //#region New ROT Data
      tabsItems: [
        { title: 'Location Info', disabled: false },
        { title: 'Container Info', disabled: false },
        { title: 'Attachments', disabled: false },
      ],
      currentTabIndex: 0,

      //#region Top Section Data
      rotNo: '',
      JobNo: '',
      jobType: '',
      rotDateTime: null,
      disableUrgent: false,
      isUrgent: false,
      customerCode: '',
      customerName: '',
      haulBillToList: [],
      selectedHaulBillTo: null,

      haulierList: [],
      selectedHaulier: null,
      rotHaulierError: '',
      haulRqtNo: '',
      haulAcceptTime: '',
      rotRequestByError: '',
      // requestedByList: [], selectedRequestedBy: null, rotRequestByError: '',
      selectedRequestedBy: null,
      RequestedByValue: '',
      rqtAcceptedBy: '',

      rotIndicator: '',
      rotPrintCount: '0',
      //#endregion

      //#region Location Info Tab
      pickupList: [],
      selectedPickup: null,
      rotPickupError: '',
      sendToList: [],
      selectedSendTo: null,
      rotSendToError: '',
      allSendToList: [],
      custSendToList: [],
      showAllSendTo: false,
      disableShowAll: false,
      tariffArea: '',
      postcode: '',
      zone: '',
      attention: '',
      telNo: '',
      address: '',

      dropoffList: [],
      selectedDropoff: null,
      rotDropoffError: '',
      tripList: [],
      selectedTrip: null,
      rotTripError: '',

      requiredDateTime: null,
      toDateTime: null,
      desc: '',
      isOfficeHours: false,
      abilityAcceptCont: '',
      timeStuffUnstuff: '',
      isOffloadAtPremises: false,
      //#endregion

      //#region Container Info Tab
      isSelectFromList: true,
      isRequestByTotalContainers: false,
      showJobContainers: false,
      showDefaultRemarks: false,
      showJobContWithoutCMR: false,
      jobContainerList: [],
      filteredJobContainerList: [],
      defaultRemarksList: [],
      selectedJobContainer: [],
      selectedDefaultRemarks: [],
      containerList: [],
      selectedContainer: [],

      containerCount: '',
      containerCountError: '',
      contSizeList: [],
      selectedConSize: null,
      selectedConSizeError: '',
      contTypeList: [],
      selectedContType: null,
      selectedContTypeError: '',
      contHdgList: [],
      selectedHdg: null,
      selectedHdgError: '',
      contDeliveryList: [],
      selectedDelivery: null,
      selectedDeliveryError: '',

      temperature: '',
      m3: '',
      weight: '',
      height: '',
      contOperator: '',
      rotContOperatorError: '',
      contLine: '',
      commodity: '',
      rotCommodityError: '',
      isFumigation: false,
      remarks: '',
      //#endregion

      //#region Attachments Tab
      selectedFiles: [],
      attachRemarks: '',
      showJobDocuments: false,
      jobDocumentsList: [],
      selectedJobDocuments: [],
      jobDocumentsLoading: false,
      attachmentList: [],
      selectedAttachments: [],
      //#endregion
      //#endregion

      //#region Update Container Status Data
      showContainerUpdate: false,
      containerUpdateJobNo: '',
      containerUpdateDetails: null,
      //#endregion

      //#region Delete Popup
      showDeleteReason: false,
      deleteMessage: '',
      deleteReason: '',
      deleteResolve: null,
      //#endregion

      showPrintPopup: false,
      disableBillingFields: false,
    };
  },
  props: {},
  methods: {
    menuClicked: async function (item) {
      this.mainFilterIsOpen = false;
      this.popupEntryViewMode = false;
      this.disableBillingFields = false;
      this.popupEntryDisabledSave = false;
      this.popupEntryCreatedBy = '';
      this.popupEntryUpdatedBy = '';
      switch (item['title']) {
        case 'New ROT': {
          this.selectedJob = null; // reset to null
          this.popupEntryViewMode = true;
          this.disableBillingFields = true;
          const currentDate = new Date();
          this.jobStartDate = new Date(currentDate);
          this.jobStartDate.setDate(currentDate.getDate() - 14);
          this.JobNo = null;
          // this.refreshJobListClicked(); //watch part already call this function
          this.disableUrgent = false; //not sure why previously is set to true
          this.popupEntryShow = true;
          this.popupEntryTitle = item['title'];
          this.popupEntryDisabledSave = true;
          //   this.$nextTick(() => { // changed to use watcher instead
          //         this.$refs['jobNo'].setFocus();
          // });
          break;
        }
        case 'Edit ROT':
          this.disableUrgent = false;
          if (this.selectedROT.length > 0) {
            this.rotFullData = await this.getROTDetails(this.selectedROT[0]['Job #']);
            if (this.rotFullData) {
              // If the this.rotFullData from the api is not null
              if (this.rotFullData['Ind'] == 'C') {
                // If the rot is cancelled
                this.$showAlert(
                  'error',
                  `Unable to edit ROT ${this.rotFullData['CMR No']} as it has already been cancelled.`,
                );
              } else {
                const result = await this.verifyROT(this.rotFullData['Job No']);
                if (!result) {
                  if (this.rotFullData['Ind'] === 'P') {
                    // if P means hauage request updated
                    if (this.rotFullData['StatusTask']) {
                      // refer getROTDetails API - dtStatusTask. If have records means already sent via eCMR (Status 2504)
                      const warning = await this.$showAlert(
                        'warning',
                        'Warning',
                        `ROT ${this.rotFullData['StatusTask']['Indicator']} already sent and haulage request # already updated.
                        \nSent Time: ${this.rotFullData['StatusTask']['actstartdate']} ${this.rotFullData['StatusTask']['actstarttime']} \n${this.rotFullData['StatusTask']['remarks']}\nHaulage Request #: ${this.rotFullData['Hau Request No']}
                        \nAre you sure you want to edit ROT ${this.rotFullData['StatusTask']['Indicator']}? `,
                        [
                          { text: 'Yes', color: 'red', textColor: 'white' },
                          { text: 'No', color: 'lightgray', textColor: 'black' },
                        ],
                      );
                      if (warning == 'No') {
                        return;
                      }
                    } else {
                      // not eCMR but haulage request updated, prompt warning
                      const warning = await this.$showAlert(
                        'warning',
                        'Warning',
                        `Haulage Request # Updated !
                        \nAre you sure you want to edit ROT ${this.rotFullData['CMR No']}? `,
                        [
                          { text: 'Yes', color: 'red', textColor: 'white' },
                          { text: 'No', color: 'lightgray', textColor: 'black' },
                        ],
                      );
                      if (warning == 'No') {
                        return;
                      }
                    }
                  } else if (this.rotFullData['StatusTask']) {
                    // if have record means already sent via eCMR
                    const warning = await this.$showAlert(
                      'warning',
                      'Warning',
                      `ROT ${this.rotFullData['StatusTask']['Indicator']} already sent. \nSent Time: ${this.rotFullData['StatusTask']['actstartdate']} ${this.rotFullData['StatusTask']['actstarttime']} \n${this.rotFullData['StatusTask']['remarks']} \nAre you sure you want to edit ROT ${this.rotFullData['StatusTask']['Indicator']}? `,
                      [
                        { text: 'Yes', color: 'red', textColor: 'white' },
                        { text: 'No', color: 'lightgray', textColor: 'black' },
                      ],
                    );
                    if (warning == 'No') {
                      return;
                    }
                  }

                  if (this.rotFullData['JobTxnCharges']) {
                    // if have record means all containers billed or paid - disable billing related fields
                    this.disableBillingFields = true;
                  } else {
                    this.disableBillingFields = false;
                  }

                  this.formatDataToPopulate();
                  this.popupEntryShow = true;
                  this.popupEntryTitle = `Edit ROT (${this.rotFullData['CMR No']})`;
                }
              }
            } else {
              this.$showAlert(
                'error',
                'No Records',
                `No records found for the selected ROT (${this.selectedROT[0]['ROT #']}).`,
              );
            }
          } else {
            this.$showAlert('error', 'No ROT Selected', 'Please select a ROT to edit');
          }
          break;
        case 'Delete ROT':
          if (this.selectedROT.length > 0) {
            const dataToPost = {
              action: 'D',
              cmrno: this.selectedROT[0]['ROT #'],
              system: 'HMS',
              job_no: this.selectedROT[0]['Job #'],
            };
            this.$fullscreenLoading('Deleting ROT');
            let result = await this.$apiCallV2('/ROT/SaveROT', dataToPost);
            this.$fullscreenLoading();
            if (result[0]['Results'] == 2) {
              const confirmDelete = new Promise((r) => (this.deleteResolve = r));
              this.showDeleteReason = true;
              this.deleteMessage = result[0]['ErrMsg'];
              const toDelete = await confirmDelete;
              if (toDelete) {
                dataToPost['answer'] = 'yes';
                dataToPost['reason'] = this.deleteReason;

                result = await this.$apiCallV2('/ROT/SaveROT', dataToPost);
                if (result[0]['Results'] == 0) {
                  this.$showAlert('success', 'ROT Delete Success', result[0]['ErrMsg']);
                  await this.refreshClicked();
                } else {
                  this.$showAlert('error', 'ROT Delete Error', result[0]['ErrMsg']);
                }
              }
            } else if (result[0]['Results'] == 1) {
              this.$showAlert('error', 'ROT Delete Error', result[0]['ErrMsg']);
            }
          } else {
            this.$showAlert('error', 'No ROT Selected', 'Please select a ROT to delete');
          }
          break;
        case 'View ROT':
          this.disableUrgent = true;
          if (this.selectedROT.length > 0) {
            this.rotFullData = await this.getROTDetails();
            if (this.rotFullData) {
              // If the this.rotFullData from the api is not null
              this.formatDataToPopulate();

              this.popupEntryShow = true;
              this.popupEntryTitle = `View ROT (${this.rotFullData['CMR No']})`;
              this.popupEntryViewMode = true;
              this.disableBillingFields = true;
            } else {
              this.$showAlert(
                'error',
                'No Records',
                `No records found for the selected ROT (${this.selectedROT[0]['ROT #']}).`,
              );
            }
          } else {
            this.$showAlert('error', 'No ROT Selected', 'Please select a ROT to view');
          }
          break;
        case 'Print ROT':
          if (this.selectedROT.length > 0) {
            this.rotFullData = await this.getROTDetails();
            if (this.rotFullData) {
              // If the this.rotFullData from the api is not null
              if (this.rotFullData['Ind'] == 'C') {
                // If the rot is cancelled
                this.$showAlert(
                  'error',
                  `Unable to print ROT ${this.rotFullData['CMR No']} as it has already been cancelled.`,
                );
              } else {
                await this.formatDataToPrint();

                this.showPrintPopup = true;
              }
            } else {
              this.$showAlert(
                'error',
                'No Records',
                `No records found for the selected ROT (${this.selectedROT[0]['ROT #']}).`,
              );
            }
          } else {
            this.$showAlert('error', 'No ROT Selected', 'Please select a ROT to print.');
          }
          break;
        case 'eROT':
          window.open(`/Home/${this.$route.params['user']}/FreightForwarding/eROT`, '_blank');
          break;
        case 'Update Cont. Status':
          if (this.selectedROT.length > 0) {
            this.showContainerUpdate = true;
            this.containerUpdateJobNo = this.selectedROT[0]['Job #'];
            this.containerUpdateDetails = { ROT: this.selectedROT[0]['ROT #'] };
            this.selectedROT['#'] = this.selectedROT['#'] || ''; //unsure why this value is needed for DocStatusUpdate, added to prevent error - weishen 20250424
          } else {
            this.$showAlert('error', 'No ROT Selected', 'Please select a ROT to update the container status.');
          }
          break;
        case 'Print Notices': {
          const printNoticesURL = `/Home/${this.$route.params.user}/FreightForwarding/Print Notice`;
          const resolvedPrintNoticesRoute = this.$router.resolve(printNoticesURL);
          window.open(resolvedPrintNoticesRoute.href, '_blank');
          break;
        }
      }
    },
    setFocusOnJobNo() {
      if (this.popupEntryTitle[0] == 'N' && this.selectedJob == null) {
        this.$nextTick(() => {
          this.$refs['jobNo'].setFocus();
        });
      }
    },
    refreshClicked: async function () {
      this.rotList = [];
      this.selectedROT = [];
      this.searchByError = '';
      this.searchByValueError = '';

      if (this.searchFilterChecked && (!this.selectedSearchBy || !this.searchByValue)) {
        this.searchByError = !this.selectedSearchBy ? 'Please select your search criteria' : '';
        this.searchByValueError = !this.searchByValue ? 'Please enter your search value' : '';
        return;
      }
      this.mainFilterIsOpen = false;

      const dataToPost = {
        startdate: this.dateFilterChecked ? new Date(this.startDate).formatString('yyyy-MM-dd') : '',
        enddate: this.dateFilterChecked ? new Date(this.endDate).formatString('yyyy-MM-dd') : '',
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.startDate).formatString('yyyy-MM-dd')} to ${new Date(this.endDate).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.startDate).formatString('yyyy-MM-dd')} to ${new Date(this.endDate).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }

      this.showFilterBox = false;
      this.$fullscreenLoading('Getting ROT Lists');
      const rotListTemp = this.$deepTrimJsonV3(await this.$apiCallV2('/ROT/GetROTListing', dataToPost));

      //create an empty column in front to show icons then only populate to rotList
      this.rotList = rotListTemp.map((r) => {
        return {
          '':
            r['Rot Status'] ?
              r['Rot Status'].trim().toLowerCase() == 'cancelled' ?
                'https://dsmlib.logistics.systems/Icons/Cancel.png'
              : ''
            : '',
          ...r,
        };
      });

      this.$fullscreenLoading();
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
    },
    getROTDetails: async function (jobno) {
      this.$fullscreenLoading('Getting ROT Details');
      const details = this.$jsonNullToStringV2(
        this.$deepTrimJsonV3(
          await this.$apiCallV2(`/ROT/GetROTDetails?cmrno=${this.selectedROT[0]['ROT #']}&jobno=${jobno ? jobno : ''}`),
        ),
      );
      this.$fullscreenLoading();
      if (Array.isArray(details)) {
        return null;
      }
      return typeof details == 'object' ? details['ROTDetails']['CMRForm'] : null;
    },
    formatDataToPrint: async function () {
      //#region Format all the dates
      this.rotFullData['formatETAPrintDateTime'] =
        this.rotFullData['ETA'] ? new Date(this.rotFullData['ETA']).formatString('yyyy-MM-dd HH:mm') : '';
      this.rotFullData['formatETAPrintDate'] =
        this.rotFullData['ETA'] ? new Date(this.rotFullData['ETA']).formatString('yyyy-MM-dd') : '';
      this.rotFullData['formatCMRTime'] =
        this.rotFullData['CMR Time'] ? new Date(this.rotFullData['CMR Time']).formatString('yyyy-MM-dd HH:mm') : '';
      this.rotFullData['formatPrintedOn'] = new Date().formatString('yyyy-MM-dd HH:mm');
      this.rotFullData['formatTimeRequiredFrom'] =
        this.rotFullData['Time Required From'] ?
          new Date(this.rotFullData['Time Required From']).formatString('yyyy-MM-dd')
        : '';
      this.rotFullData['formatDateTimeRequiredFrom'] =
        this.rotFullData['Time Required From'] ?
          new Date(this.rotFullData['Time Required From']).formatString('yyyy-MM-dd HH:mm')
        : '';
      //#endregion

      const HaulierObject = this.haulierList.getSelected(this.rotFullData['Haulier Code'], 'Haulier Code');
      if (HaulierObject) {
        this.rotFullData['Haulier'] = HaulierObject['Description'];
      }

      //#region Format the container summary to remove all the Type
      let containerSummary = this.rotFullData['Cont Summary'];
      this.contTypeList.forEach((c) => {
        if (containerSummary.includes(c['Cont Type'])) {
          containerSummary = containerSummary.replace(new RegExp(c['Cont Type'], 'g'), '`');
        }
      });
      this.rotFullData['formatContainerSize'] = containerSummary;
      //#endregion

      this.rotFullData['Weight'] = parseFloat(this.rotFullData['Weight']).toFixed(2);
      this.rotFullData['Weight (Tonne)'] = parseFloat(this.rotFullData['Weight (Tonne)']).toFixed(2);
      this.rotFullData['M3'] = parseFloat(this.rotFullData['M3']).toFixed(2);

      this.rotFullData['Seal No'] =
        this.rotFullData['ContDetail'] ?
          Array.isArray(this.rotFullData['ContDetail']) ?
            this.rotFullData['ContDetail'][0]['Seal No']
          : ''
        : '';

      this.rotFullData['Bill To Contact'] =
        this.rotFullData['Bill To Contact'] == 'Tel: / Fax:' ? '' : this.rotFullData['Bill To Contact'];

      if (this.rotFullData['ContDetail']) {
        this.rotFullData['ContDetail'] = this.rotFullData['ContDetail'].filter(
          (c) => !c['Cont No'].toLowerCase().includes('tempcontno'),
        );
        if (this.rotFullData['ContDetail'].length > 10) {
          this.rotFullData['ContDetailLong'] = this.rotFullData['ContDetail'];
        }

        //to get the date demurage and datedetention onto main object.
        const Top1DateDemurageObj = this.rotFullData['ContDetail'].find((f) => f['Date Demurage']);
        const Top1DateDetentionObj = this.rotFullData['ContDetail'].find((f1) => f1['Date Detention']);
        if (Top1DateDemurageObj) {
          this.rotFullData['Date Demurage'] = Top1DateDemurageObj['Date Demurage'];
        }
        if (Top1DateDetentionObj) {
          this.rotFullData['Date Detention'] = Top1DateDetentionObj['Date Detention'];
        }
      }

      if (this.rotFullData['ContDetailLong']) {
        delete this.rotFullData['ContDetail'];
        this.rotFullData['ContMessage'] = 'Please refer to container attachment.';
        this.rotFullData['ContDetailLong'].forEach((c) => {
          c['SizeType'] = `${c['Size']}${c['Cont Type']}`;
          if (c['Required Time']) {
            const time = c['Required Time'].split('');
            time.splice(2, 0, ':');
            c['Required DateTime'] = `${new Date(c['Required DateTime']).formatString('yyyy-MM-dd')} ${time.join('')}`;
          }
        });
      } else if (this.rotFullData['ContDetail']) {
        this.rotFullData['ContDetail'].forEach((c) => {
          if (c['Required Time']) {
            const time = c['Required Time'].split('');
            time.splice(2, 0, ':');
            c['Required Time'] = time.join('');
          }
          c['Required DateTime'] = new Date(c['Required DateTime']).formatString('yyyy-MM-dd');
        });
      }

      //#region FOR IW ROT Forms
      this.rotFullData['isOffLoad'] = this.rotFullData['Offload At Premis'] == '1' ? 'X' : '';

      this.rotFullData['isExp'] = this.rotFullData['Job Type'] == 'EXPORT' ? 'X' : '';
      this.rotFullData['isOneWayExp'] =
        this.rotFullData['Job Type'] == 'EXPORT' && this.rotFullData['Trip Desc'] == '1-WAY' ? 'X' : '';
      this.rotFullData['isSLExp'] =
        this.rotFullData['Job Type'] == 'EXPORT' && this.rotFullData['Sideloader Label'] ? 'X' : '';

      this.rotFullData['isImp'] = this.rotFullData['Job Type'] == 'IMPORT' ? 'X' : '';
      this.rotFullData['isOneWayImp'] =
        this.rotFullData['Job Type'] == 'IMPORT' && this.rotFullData['Trip Desc'] == '1-WAY' ? 'X' : '';
      this.rotFullData['isSLImp'] =
        this.rotFullData['Job Type'] == 'IMPORT' && this.rotFullData['Sideloader Label'] ? 'X' : '';
      //#endregion

      //#region FOR MH ROT Forms
      this.rotFullData['isOfficeHrs'] = this.rotFullData['Office Hours Label'].includes('ffice') ? 'X' : '';
      this.rotFullData['isTwentyFourHrs'] = !this.rotFullData['Office Hours Label'].includes('ffice') ? 'X' : '';
      this.rotFullData['isTR'] = this.rotFullData['Delivery Type'] == 'TR' ? 'X' : '';
      this.rotFullData['isSL'] = this.rotFullData['Delivery Type'] != 'TR' ? 'X' : '';
      //#endregion

      //#region Format Send To Address
      const sendToAddress = [
        this.rotFullData['Send To Add1'],
        this.rotFullData['Send To Add2'],
        this.rotFullData['Send To Add3'],
        this.rotFullData['Send To Add4'],
        `${this.rotFullData['Send To PostCode']} ${this.rotFullData['Send To City']}, ${this.rotFullData['Send To State']}`,
        this.rotFullData['Send To Country'],
      ];
      this.rotFullData['formatSendToAddress'] = sendToAddress.filter((s) => s).join('\n');
      //#endregion

      //#region Haul Bill To name, address
      const haulBilltoListTemp = this.$deepTrimJsonV3(
        await this.$apiCallV2(
          `/ROT/GetROTHaulBillTo?customercode=${this.rotFullData['Cu Number']}&billcust=${this.rotFullData['CMR Bill To']}`,
        ),
      )['BillToLists']['BillToList'];
      const selectedHaulBillToTemp = haulBilltoListTemp.getSelected(this.rotFullData['CMR Bill To'], 'BillTo');

      if (selectedHaulBillToTemp) {
        this.rotFullData['CMR Bill To Name'] = selectedHaulBillToTemp['BillToName'];
        this.rotFullData['CMR Bill To Addr1'] = selectedHaulBillToTemp['Addr1'];
        this.rotFullData['CMR Bill To Addr2'] = selectedHaulBillToTemp['Addr2'];
        this.rotFullData['CMR Bill To Addr3'] = selectedHaulBillToTemp['Addr3'];
        this.rotFullData['CMR Bill To Addr4'] = selectedHaulBillToTemp['Addr4'];
        this.rotFullData['CMR Bill To Phone'] = selectedHaulBillToTemp['Phone'];
      }
      //#endregion
    },
    formatDataToPopulate: async function () {
      this.popupEntryCreatedBy =
        this.rotFullData['Created by'] ?
          this.rotFullData['Created Time'] ?
            `${this.rotFullData['Created by']} ${this.rotFullData['Created Time']}`
          : this.rotFullData['Created by']
        : '';
      this.popupEntryUpdatedBy =
        this.rotFullData['User ID'] ?
          this.rotFullData['Date Update'] ?
            `${this.rotFullData['User ID']} ${this.rotFullData['Date Update']}`
          : this.rotFullData['User ID']
        : '';

      //#region Top Section
      this.rotNo = this.rotFullData['CMR No'];
      this.JobNo = this.rotFullData['Job No'];
      this.jobType = this.rotFullData['Job_Type'];
      this.rotDateTime = new Date(this.rotFullData['CMR Time']);
      this.isUrgent = this.rotFullData['Urgency'] == '1';
      this.customerCode = this.rotFullData['Cu Number'];
      this.$fullscreenLoading('Getting Cust Send To List');
      this.custSendToList = this.$deepTrimJsonV3(
        await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'sendto', cu_number: this.customerCode }),
      );
      this.custSendToList = this.custSendToList.map((sendto) => ({
        ...sendto,
        'Code - Company': `${sendto['Destination Code']} - ${sendto['Company']}`,
      }));
      this.$fullscreenLoading();
      this.customerName = this.rotFullData['Cu Name'];
      this.$fullscreenLoading('Getting Haul Bill To');
      this.haulBillToList = this.$deepTrimJsonV3(
        await this.$apiCallV2(
          `/ROT/GetROTHaulBillTo?customercode=${this.rotFullData['Cu Number']}&billcust=${this.rotFullData['CMR Bill To']}`,
        ),
      )['BillToLists']['BillToList'];
      this.$fullscreenLoading();
      // this.selectedHaulBillTo = this.haulBillToList.find(f => f['Default'] == '1');
      //this.selectedHaulBillTo = this.haulBillToList.getSelected(this.jobDetails['billcu_no'], 'BillTo');
      // if (!this.selectedHaulBillTo)
      this.$nextTick(
        () => (this.selectedHaulBillTo = this.haulBillToList.getSelected(this.rotFullData['CMR Bill To'], 'BillTo')),
      );

      this.selectedHaulier = this.haulierList.getSelected(this.rotFullData['Haulier Code'], 'Haulier Code');
      this.haulRqtNo = this.rotFullData['Hau Request No'];
      // this.haulAcceptTime = this.rotFullData['Haul Accept Time'];
      this.haulAcceptTime = this.rotFullData['Hau Request Time'];
      // this.requestedBy = this.rotFullData['Requested By'];
      this.selectedRequestedBy =
        this.rotFullData['Requested By'] ?
          this.requestedByList.getSelected(this.rotFullData['Requested By'], 'EmployeeID')
        : '';
      if (this.rotFullData['Requested By'] && !this.selectedRequestedBy) {
        this.RequestedByValue = this.rotFullData['Requested By'];
      }
      this.rqtAcceptedBy = this.rotFullData['Hau Accepted By'];

      this.rotIndicator = this.rotFullData['Ind'];
      this.rotPrintCount = this.rotFullData['Print Count'];
      //#endregion

      //#region Location Info Tab
      this.showAllSendTo = true;
      this.selectedPickup = this.pickupList.getSelected(this.rotFullData['Pick Up'], 'Destination Code');
      await this.$nextTick();
      this.selectedSendTo = this.sendToList.getSelected(this.rotFullData['Destination Code'], 'Destination Code');
      await this.$nextTick();
      this.tariffArea = this.selectedSendTo ? this.selectedSendTo['Tariff Area'] : '';
      this.postcode = this.selectedSendTo ? this.selectedSendTo['PostCode'] : '';
      this.zone = this.selectedSendTo ? this.selectedSendTo['Zone'] : '';
      this.attention = this.selectedSendTo ? this.selectedSendTo['Attn'] : '';
      this.telNo = this.selectedSendTo ? this.selectedSendTo['Phone'] : '';
      if (this.rotFullData['Address']) {
        this.address = this.rotFullData['Address'];
      }

      this.selectedDropoff = this.dropoffList.getSelected(this.rotFullData['Drop Off'], 'Destination Code');
      this.selectedTrip = this.tripList.getSelected(this.rotFullData['Trip'], 'Trip');

      this.requiredDateTime = new Date(this.rotFullData['Time Required From']);
      this.toDateTime = new Date(this.rotFullData['Time Required To']);
      this.desc = this.rotFullData['Req Time Description'];
      this.isOfficeHours = this.rotFullData['Office Hours'] == '1';
      this.abilityAcceptCont = this.rotFullData['AA Cont No'];
      this.timeStuffUnstuff = this.rotFullData['Time Needed'];
      this.isOffloadAtPremises = this.rotFullData['Offload At Premis'] == '1';
      //#endregion

      //#region Container Info Tab
      this.isSelectFromList = true;
      this.isRequestByTotalContainers = false;
      this.showJobContainers = false;
      this.showDefaultRemarks = false;
      this.$fullscreenLoading('Getting Container List');
      this.containerList =
        this.rotFullData['ContDetail'] ?
          this.rotFullData['ContDetail'].map((c) => {
            return {
              '#': c['#'],
              'Container #': c['Cont No'],
              'CMR #': c['CMR No'],
              'Job Type': c['Job Type'],
              'Seal No': c['Seal No'] || '',
              Size: c['Size'],
              Type: c['Cont Type'],
              Handling: c['Handling Type'],
              Delivery: c['Delivery Type'],
              'Haul. Tariff': c['Haul. Tariff'],
              Toll: c['Toll'],
              FAF: c['FAF'],
              Total: c['Total'],
              tag: c['tag'],
            };
          })
        : [];

      this.populateContainerList();
      this.$fullscreenLoading();

      this.temperature = this.rotFullData['Temperature'];
      this.m3 = this.rotFullData['M3'];
      this.weight = this.rotFullData['Weight'];
      this.height = this.rotFullData['Height'];
      this.contOperator = this.rotFullData['Container Operator'];
      this.contLine = this.rotFullData['Container Line'];
      this.commodity = this.rotFullData['Commodity'];
      this.isFumigation = this.rotFullData['Fumigation'] == '1';
      this.remarks = this.rotFullData['Remarks'];
      //#endregion
    },
    //#region InputQuery Refresh Clicked Handlers
    pickupInputQueryRefreshClicked: async function (placeholder) {
      this.pickupList = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.pickupList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'pickup' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Pick Up" :isRequired="true" :items="pickupList" :selectedObject.sync="selectedPickup"
      //             itemKey="Destination Code" descKey="Company" ref="rotPickup" :errorMessage.sync="rotPickupError" :isDisabled="popupEntryViewMode" :refreshData="{ masterfile: 'pickup' }" />
    },
    sendToInputQueryRefreshClicked: async function (placeholder) {
      this.sendToList = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.sendToList = await this.$apiCallV2('/Master/GetListMaster', this.sendtoRefreshData);
      this.$fullscreenLoading();
      // <InputQuery placeholder="Send To" :isRequired="true" :items="sendToList" :selectedObject.sync="selectedSendTo"
      //               itemKey="Destination Code" descKey="Company" ref="rotSendTo" :errorMessage.sync="rotSendToError" :isDisabled="popupEntryViewMode" :refreshData="sendtoRefreshData" />
    },
    dropoffInputQueryRefreshClicked: async function (placeholder) {
      this.dropoffList = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.dropoffList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'dropoff' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Drop Off" :isRequired="true" :items="dropoffList" :selectedObject.sync="selectedDropoff"
      //             itemKey="Destination Code" descKey="Company" ref="rotDropoff" :errorMessage.sync="rotDropoffError" :isDisabled="popupEntryViewMode" :refreshData="{ masterfile: 'dropoff' }" />
    },

    //#endregion

    //#region Job Selection Methods
    // jobNoNextClicked: function() {
    //   if (!this.jobNoInput) {
    //     this.jobNoInputError = 'Job No is Required!';
    //   } else {
    //     this.verifyJobNo(this.jobNoInput);
    //   }
    // },
    refreshJobListClicked: async function () {
      this.$fullscreenLoading('Getting Job List');
      this.jobList = [];

      this.jobList = this.$deepTrimJsonV3(
        await this.$apiCallV2(
          `/ROT/GetRotJob?startdate=${this.jobStartDate.formatString('yyyy-MM-dd')}&enddate=${this.jobEndDate.formatString('yyyy-MM-dd')}`,
        ),
      );
      this.$fullscreenLoading();
    },
    jobListTableSelect: function (data) {
      this.verifyJobNo(data['Job #']);
      this.popupEntryViewMode = false;
      this.disableBillingFields = false;
    },
    verifyJobNo: async function (jobno) {
      this.popupEntryErrorMessage = [];
      this.$fullscreenLoading('Verify Job No');
      const details = await this.$apiCallV2(`/ROT/ValidateJobsForROT?jobno=${jobno}`);
      this.$fullscreenLoading();
      //YENKHAI details does not show job type, require those details to link to freight forwardin

      if (details[0]['Results'] == 1) {
        const err = details[0]['ErrMsg'].split('\n');
        this.popupEntryErrorMessage.push(err[0], err[1]);
        const fill = await this.$showAlert('warning', err[0], err[1], [
          { text: 'Fill Now', textColor: 'white', color: 'green' },
          { text: 'Cancel', textColor: 'white', color: 'red' },
        ]);
        if (fill == 'Fill Now') {
          this.userParam = this.$route.params['user'];
          this.$router.push(`/Home/${this.userParam}/FreightForwarding/${details[0]['URLLinkParameter']}&edit=Y`);
          //key from stanley should be "ImportJob/jobno&date"
        } else {
          this.selectedJob = null;
        }
      } else {
        this.popupEntryTitle = 'New ROT';
        this.popupEntryDisabledSave = false;
        this.jobDetails = this.$jsonNullToStringV2(this.$deepTrimJsonV3(details[0])); //this wont have anything if got err
        this.populateNewJobData();
      }
    },
    //#endregion

    //#region New ROT Methods
    populateNewJobData: async function () {
      //#region Top Section Data
      //YENKHAI all these will have no value if err
      this.rotNo = this.jobDetails['ROT'] == '' ? '******' : this.jobDetails['ROT'];
      this.JobNo = this.jobDetails['Job_no'];
      this.jobType = this.jobDetails['Job_Type'];
      this.rotDateTime = new Date();
      this.isUrgent = this.jobDetails['urgent'] == '1';
      this.customerCode = this.jobDetails['cu_number'];

      this.$fullscreenLoading('Getting Defaults');
      const defaults = await this.$apiCallV2(`/FreightForwarding/GetJobDefaults?jobType=CMR`);
      if (defaults['ContOperator']) {
        this.contOperator = defaults['ContOperator'];
      }
      if (defaults['Haulier']) {
        this.selectedHaulier = this.haulierList.getSelected(defaults['Haulier'], 'Haulier Code');
      }
      if (defaults['Trip']) {
        this.selectedTrip = this.tripList.getSelected(defaults['Trip'], 'Trip');
      } else {
        this.selectedTrip = this.tripList[0]; //default to first record.
      }

      this.$fullscreenLoading('Getting Cust Send To List');
      this.custSendToList = this.$deepTrimJsonV3(
        await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'sendto', cu_number: this.customerCode }),
      );
      this.custSendToList = this.custSendToList.map((sendto) => ({
        ...sendto,
        'Code - Company': `${sendto['Destination Code']} - ${sendto['Company']}`,
      }));
      if (this.custSendToList.length < 1) {
        this.showAllSendTo = true;
        this.disableShowAll = true;
      }
      this.$fullscreenLoading();
      this.customerName = this.jobDetails['cu_name'];
      this.$fullscreenLoading('Getting Haul Bill To');
      this.haulBillToList = this.$deepTrimJsonV3(
        await this.$apiCallV2(
          `/ROT/GetROTHaulBillTo?customercode=${this.jobDetails['cu_number']}&billcust=${this.jobDetails['billcu_no']}`,
        ),
      )['BillToLists']['BillToList'];
      this.$fullscreenLoading();
      this.selectedHaulBillTo = this.haulBillToList.find((f) => f['Default'] == '1');
      if (!this.selectedHaulBillTo)
        this.selectedHaulBillTo = this.haulBillToList.getSelected(this.jobDetails['billcu_no'], 'BillTo');

      this.m3 = this.jobDetails['Measurement'] ?? '';
      this.weight = this.jobDetails['GWeight'] ?? '';
      // this.selectedHaulier = this.haulierList.getSelected(this.jobDetails['keytochange'], 'CodeToChange');
      // this.haulRqtNo = this.jobDetails['keytochange'];
      // this.haulAcceptTime = this.jobDetails['keytochange'];
      // this.selectedRequestedBy = this.requestedByList.getSelected(this.jobDetails['RequestedBy'], 'codetochange'); //qyvoon comment out
      // this.requestedBy = this.$store.state.loginDetails['LoginUserId'];
      this.RequestedByValue = this.$store.state.loginDetails['UserName'];
      this.RequestedByValue = this.RequestedByValue.substring(0, 10);
      // this.rqtAcceptedBy = this.jobDetails['keytochange'];
      //#endregion

      //#region Location Info Tab
      if (this.jobType == 'I') {
        this.selectedPickup = this.pickupList.getSelected(this.jobDetails['Operator_code'], 'Destination Code');
      } else if (this.jobType == 'E') {
        this.selectedSendTo = this.sendToList.getSelected(this.jobDetails['Operator_code'], 'Destination Code');
      }
      // this.pickupList = this.jobDetails['keytochange'];
      // this.selectedPickup = this.jobDetails['keytochange'];
      if (!this.showAllSendTo) {
        this.sendToList = this.custSendToList;
      } else {
        this.sendToList = this.allSendToList;
      }
      // this.selectedSendTo = this.jobDetails['keytochange'];
      // this.showAllSendTo = this.jobDetails['keytochange'];
      // this.tariffAreaList = this.jobDetails['keytochange'];
      // this.selectedTariffArea = this.jobDetails['keytochange'];
      // this.postcode = this.jobDetails['keytochange'];
      // this.zone = this.jobDetails['keytochange'];
      // this.attention = this.jobDetails['keytochange'];
      // this.telNo = this.jobDetails['keytochange'];
      // this.address = this.jobDetails['keytochange'];

      // this.dropoffList = this.jobDetails['keytochange'];
      // this.selectedDropoff = this.jobDetails['keytochange'];
      // this.tripList = this.jobDetails['keytochange'];
      if (this.jobDetails['Date_ETA']) {
        let dateeta =
          this.jobDetails['Date_ETA'].substring(0, 10) +
          (this.jobDetails['Time_ETA'] ?
            'T' + this.jobDetails['Time_ETA'].substring(0, 2) + ':' + this.jobDetails['Time_ETA'].substring(2, 4)
          : '');
        dateeta = dateeta.trim();
        this.requiredDateTime = new Date(dateeta);
        this.toDateTime = new Date(dateeta);
      }
      // this.desc = this.jobDetails['keytochange'];
      // this.isOfficeHours = this.jobDetails['keytochange'];
      // this.abilityAcceptCont = this.jobDetails['keytochange'];
      // this.timeStuffUnstuff = this.jobDetails['keytochange'];
      // this.isOffloadAtPremises = this.jobDetails['keytochange'];
      //#endregion

      //#region Container Info Tab
      //YENKHAI therefore here will be null job num
      this.$fullscreenLoading('Getting Container List');
      // this.jobContainerList = await this.$apiCallV2(`/ROT/GetRotCont?jobno=${this.JobNo}&showall=1`);
      this.populateContainerList();
      // this.filteredJobContainerList = this.jobContainerList;
      // this.filteredJobContainerList = JSON.parse(JSON.stringify(this.jobContainerList));
      this.$fullscreenLoading();
      // this.isSelectFromList = this.jobDetails['keytochange'];
      // this.isRequestByTotalContainers = this.jobDetails['keytochange'];
      // this.containerList = this.jobDetails['keytochange'];
      // this.selectedContainer = this.jobDetails['keytochange'];

      // this.temperature = this.jobDetails['keytochange'];
      // this.m3 = this.jobDetails['keytochange'];
      // this.weight = this.jobDetails['keytochange'];
      // this.height = this.jobDetails['keytochange'];
      // this.contOperator = this.jobDetails['keytochange'];
      // this.contLine = this.jobDetails['keytochange'];
      this.commodity = this.jobDetails['CommodityDesc'];
      this.isFumigation = this.jobDetails['Fumigation'] == '1';
      // this.remarks = this.jobDetails['keytochange'];
      //#endregion

      // //#region Attachments Tab
      // this.selectedFiles = this.jobDetails['keytochange'];
      // this.attachRemarks = this.jobDetails['keytochange'];
      // this.attachmentList = this.jobDetails['keytochange'];
      // this.selectedAttachments = this.jobDetails['keytochange'];
      // //#endregion
    },
    containerInfoCheckBoxClicked: async function (type) {
      if (type == 'select') {
        this.isRequestByTotalContainers = !this.isSelectFromList;
      } else {
        this.isSelectFromList = !this.isRequestByTotalContainers;
      }

      if (this.containerList.length > 0 && !this.isSelectFromList) {
        const confirmChanged = await this.$showAlert(
          'warning',
          'Selection Change',
          'There are unsaved container changes.<br>If you confirm, the container list will be removed.',
          [{ text: 'Confirm' }, { text: 'Cancel', color: 'gray', textColor: 'white' }],
        );

        if (confirmChanged == 'Cancel') {
          this.isSelectFromList = true;
          this.isRequestByTotalContainers = false;
        } else {
          this.containerList = [];
        }
      } else if (
        !this.isRequestByTotalContainers &&
        (this.containerCount ||
          this.selectedContType ||
          this.selectedConSize ||
          this.selectedHdg ||
          this.selectedDelivery)
      ) {
        const confirmChanged = await this.$showAlert(
          'warning',
          'Selection Change',
          'There are unsaved container changes.<br>If you confirm, the container details will be removed.',
          [{ text: 'Confirm' }, { text: 'Cancel', color: 'gray', textColor: 'white' }],
        );
        if (confirmChanged == 'Cancel') {
          this.isRequestByTotalContainers = true;
          this.isSelectFromList = false;
        } else {
          this.containerCount = '';
          this.selectedContType = null;
          this.selectedConSize = null;
          this.selectedHdg = null;
          this.selectedDelivery = null;
        }
      }
    },
    saveClicked: async function (action) {
      this.popupEntryMessages = [];
      this.popupEntryErrorMessage = [];
      this.popupEntrySuccessMessage = [];
      this.popupEntryRequiredError = [];

      if (!action) {
        this.popupEntryRequiredError = this.compulsoryChecking();
      }

      if (this.popupEntryRequiredError.length == 0) {
        // return;
        const rotSaveData = {
          updatedBy: '',
          ind: '',
          action: action ? action : this.popupEntryTitle[0],
          cmrno: this.rotNo,
          job_no: this.JobNo,
          cmrdate: this.rotDateTime ? this.rotDateTime.formatString('yyyy-MM-dd') : '',
          cmrtime: this.rotDateTime ? this.rotDateTime.formatString('HHmm') : '',
          haulier_code: this.selectedHaulier ? this.selectedHaulier['Haulier Code'] : '',
          pickup: this.selectedPickup ? this.selectedPickup['Destination Code'] : '',
          dropoff: this.selectedDropoff ? this.selectedDropoff['Destination Code'] : '',
          urgency: this.isUrgent ? '1' : '0',
          haurequestno: this.haulRqtNo,
          haurequestdate: this.haulAcceptTime ? this.haulAcceptTime.formatString('yyyy-MM-dd') : '',
          haurequesttime: this.haulAcceptTime ? this.haulAcceptTime.formatString('HHmm') : '',
          hauacceptedby: this.rqtAcceptedBy,
          requestedby: this.selectedRequestedBy ? this.selectedRequestedBy['EmployeeID'] : this.RequestedByValue,
          // 'requestedby': this.requestedBy,
          trip: this.selectedTrip ? this.selectedTrip['Trip'] : '',
          daterequiredfrom: this.requiredDateTime ? this.requiredDateTime.formatString('yyyy-MM-dd') : '',
          timerequiredfrom: this.requiredDateTime ? this.requiredDateTime.formatString('HHmm') : '',
          daterequiredto: this.toDateTime ? this.toDateTime.formatString('yyyy-MM-dd') : '',
          timerequiredto: this.toDateTime ? this.toDateTime.formatString('HHmm') : '',
          reqtimedesc: this.desc,
          officehrs: this.isOfficeHours ? '1' : '0',
          consignee: '',
          destination_code: this.selectedSendTo ? this.selectedSendTo['Destination Code'] : '',
          // 'chamareacode': !data['TariffArea'] ? '' : data['TariffArea']['Tariff Area'],
          chamareacode: this.tariffArea,
          aacontno: this.abilityAcceptCont || '0',
          timeneeded: this.timeStuffUnstuff || '0',
          commodity: this.commodity,
          totalcont: this.isSelectFromList ? this.containerList.length : this.containerCount, // double check
          contline: this.contLine,
          contoperator: this.contOperator,
          temperature: this.temperature,
          m3: this.m3 || '0',
          height: this.height || '0',
          weight: this.weight || '0',
          requestno: '',
          curefno: '',
          printcount: '0',
          dateupdated: '',
          status: '2100',
          datedemurage: '',
          datedetention: '',
          datebacktodepot: '',
          datefreestorage: '',
          datemonitor: '',
          total_charges: '',
          actual_charges: '',
          haulagerate: '',
          tollrate: '',
          remarks: this.remarks,
          offloadatpremis: this.isOffloadAtPremises ? '1' : '0',
          address: this.address,
          fumigation: this.isFumigation ? '1' : '0',
          cmrbillto: this.selectedHaulBillTo ? this.selectedHaulBillTo['BillTo'] : '',
          jobbillto: '-',
          customercode: this.customerCode,
          option: this.isSelectFromList ? '1' : '0',
          system: 'CON',
          jobtype: this.jobType,
        };

        if (this.isSelectFromList) {
          // Option is select from list
          rotSaveData['contsize'] = this.containerList[0]['Size'];
          rotSaveData['conttype'] = this.containerList[0]['Type'];
          rotSaveData['handlingtype'] = this.containerList[0]['Handling'];
          rotSaveData['deliverytype'] = this.containerList[0]['Delivery'];

          rotSaveData['selectedcontainer'] = this.containerList.map((c) => {
            return {
              contno: c['Container #'] ? c['Container #'] : '',
              cmrno: c['CMR #'] ? c['CMR #'] : '',
              jobtype: c['Job Type'] ? c['Job Type'] : '',
              sealno: c['Seal No'] ? c['Seal No'] : '',
              contsize: c['Size'] ? c['Size'] : '',
              conttype: c['Type'] ? c['Type'] : '',
              handling: c['Handling'] ? c['Handling'] : '',
              delivery: c['Delivery'] ? c['Delivery'] : '',
              tag: c['tag'] ? c['tag'] : '',
            };
          });
        } else {
          // Option is request by cont count
          rotSaveData['contsize'] = this.selectedConSize['Size'] ? this.selectedConSize['Size'] : '';
          rotSaveData['conttype'] = this.selectedContType['Cont Type'] ? this.selectedContType['Cont Type'] : '';
          rotSaveData['handlingtype'] = this.selectedHdg['Handling Type'] ? this.selectedHdg['Handling Type'] : '';
          rotSaveData['deliverytype'] =
            this.selectedDelivery['Delivery Type'] ? this.selectedDelivery['Delivery Type'] : '';
        }

        this.$fullscreenLoading('Saving ROT');
        const rotSave = await this.$apiCallV2('/ROT/SaveROT', rotSaveData);
        this.$fullscreenLoading();

        if (rotSave[0]['Results'] == 0) {
          this.popupEntrySuccessMessage.push(
            `Successfully ${rotSaveData['action'] == 'N' ? 'created' : 'edited'} a ROT. CMR No: ${rotSaveData['action'] == 'N' ? rotSave[0]['CMRNO'] : rotSaveData['cmrno']}`,
          );
          //display rot number instead of ****** it doesnt get refreshed i think???
          this.rotNo = rotSave[0]['CMRNO'];
          this.disableUrgent = true;
          this.popupEntryViewMode = true;
          this.disableBillingFields = true;
          this.popupEntryTitle = `View ROT (${rotSaveData['action'] == 'N' ? rotSave[0]['CMRNO'] : rotSaveData['cmrno']})`;
          this.popupEntryDisabledSave = true;
          await this.refreshClicked();
        }
      }
    },
    compulsoryChecking: function () {
      const errorMessage = [];

      if (!this.selectedHaulier) {
        errorMessage.push({ key: 'rotHaulier', value: 'Haulier is Required' });
        this.rotHaulierError = 'Haulier is Required';
      }
      if (!this.selectedRequestedBy) {
        // if (!this.requestedBy) {
        if (!this.RequestedByValue) {
          errorMessage.push({ key: 'rotRequestBy', value: 'Request By is Required' });
          this.rotRequestByError = 'Request By is Required';
        }
      }
      if (!this.selectedPickup) {
        errorMessage.push({ key: 'rotPickup', value: 'Pickup is Required' });
        this.rotPickupError = 'Pickup is Required';
      }
      if (!this.selectedSendTo) {
        errorMessage.push({ key: 'rotSendTo', value: 'Send To is Required' });
        this.rotSendToError = 'Send To is Required';
      }
      if (!this.selectedDropoff) {
        errorMessage.push({ key: 'rotDropoff', value: 'Dropoff is Required' });
        this.rotDropoffError = 'Dropoff is Required';
      }
      if (!this.selectedTrip) {
        errorMessage.push({ key: 'rotTrip', value: 'Trip is Required' });
        this.rotTripError = 'Trip is Required';
      }
      if (!this.contOperator) {
        errorMessage.push({ key: 'rotContOperator', value: 'Cont. Operator is Required' });
        this.rotContOperatorError = 'Cont. Operator is Required';
      }
      if (!this.commodity) {
        errorMessage.push({ key: 'rotCommodity', value: 'Commodity is Required' });
        this.rotCommodityError = 'Commodity is Required';
      }
      if (this.isSelectFromList && this.containerList.length == 0) {
        errorMessage.push({ key: 'containerListing', value: 'Please choose at least one container' });
      }
      if (this.isRequestByTotalContainers) {
        if (!this.containerCount) {
          errorMessage.push({ key: 'contCount', value: 'No of Container is Required' });
          this.containerCountError = 'No of Container is Required';
        }
        if (!this.selectedConSize) {
          errorMessage.push({ key: 'contSize', value: 'Container Size is Required' });
          this.selectedConSizeError = 'Container Size is Required';
        }
        if (!this.selectedContType) {
          errorMessage.push({ key: 'contType', value: 'Container Type is Required' });
          this.selectedContTypeError = 'Container Type is Required';
        }
        if (!this.selectedHdg) {
          errorMessage.push({ key: 'hdgType', value: 'Handling Type is Required' });
          this.selectedHdgError = 'Handling Type is Required';
        }
        if (!this.selectedDelivery) {
          errorMessage.push({ key: 'deliveryType', value: 'Delivery Type is Required' });
          this.selectedDeliveryError = 'Delivery Type is Required';
        }
      }

      return errorMessage;
    },
    popupRequiredClicked: function (key) {
      const tabIndex = this.requiredErrorIndexMapping.find((e) => e['key'] == key);

      if (this.currentTabIndex != tabIndex['index'] && tabIndex['index'] != -1) {
        this.currentTabIndex = tabIndex['index'];
      }

      if (key != 'containerListing') {
        this.$nextTick(() => this.$refs[key].setFocus());
      }
    },
    //#endregion

    //#region Container Info Tab Methods
    addDefaultRemarksClicked: async function () {
      this.$fullscreenLoading('Loading');
      this.showDefaultRemarks = true;
      this.selectedDefaultRemarks = []; // reset selected
      this.defaultRemarksList = [];
      const result = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FORWARDING_AGENT' });
      const remarksData = JSON.parse(result[0]['addinfojson'])?.['ROTDefaults']?.['Remarks'] || [];

      setTimeout(() => {
        this.defaultRemarksList = remarksData.map((item, index) => {
          return { '#': index + 1, ...item }; // add seq no
        });
      }, 300);

      this.$fullscreenLoading();
    },
    addContainerClicked: function () {
      this.showJobContWithoutCMR = false;
      this.selectedJobContainer = [];
      this.filteredJobContainerList = [];
      this.showJobContainers = true;
      // await this.$nextTick(() => {
      //   this.filteredJobContainerList = this.jobContainerList;
      // })
      setTimeout(() => {
        //use timeout because popup animation takes time and only load after it complete the animation
        const containerNo = this.containerList.map((c) => {
          return c['Container #'];
        });

        const tempDeletedContainer = this.containerList
          .filter((a) => a['tag'] == '5')
          .map((d) => {
            return d['Container #'];
          });
        this.filteredJobContainerList = this.jobContainerList.filter(
          (a) => !containerNo.includes(a['Container #']) || tempDeletedContainer.includes(a['Container #']),
        );
      }, 500);
    },
    deleteContainerClicked: function () {
      if (this.selectedContainer.length == 0) {
        this.$showAlert(
          'error',
          'No Container Selected',
          'Please select at least 1 container to delete from the list.',
        );
      } else {
        if (this.selectedContainer[0]['tag'] == '3') {
          //billed cannot remove
          this.$showAlert('error', 'Container Selected billed', 'Cannot removed container that already billed.');
          return;
        }
        const temp = this.containerList;

        this.selectedContainer.forEach((c) => {
          const index = temp.findIndex((d) => {
            return d['Container #'] == c['Container #'];
          });
          if (c['tag'] == '2') {
            //tag 2 = this cmr container
            temp[index]['tag'] = '5'; //delete tag
          } else {
            //tag 1 = container without cmr #
            temp.splice(index, 1);
          }
        });

        this.containerList = [];
        this.$nextTick(() => {
          this.containerList = temp;
          this.selectedContainer = [];
        });
      }
    },
    defaultRemarksButtonClicked: function (text) {
      if (text.includes('Add')) {
        if (this.selectedDefaultRemarks.length == 0) {
          this.$showAlert('error', 'No Remarks Selected', 'Please select a default remark to add.');
          return;
        }
        const joinRemarks = this.selectedDefaultRemarks.map((item) => item['Remarks']).join('\n'); // join all selected remarks
        if (joinRemarks.length > 200) {
          // check if exceed 200 char
          this.$showAlert('error', 'Remarks Too Long', 'The total character length of remarks cannot exceed 200.');
          return;
        }
        this.remarks = joinRemarks;
      }
      this.showDefaultRemarks = false;
    },
    jobContainerButtonClicked: async function (text) {
      let addedContainerList = [];
      if (text.includes('Confirm')) {
        const hasCMR = this.$deepTrimJsonV3(this.selectedJobContainer).filter(
          (c) => c['CMR #'] && c['CMR #'] != this.rotNo,
        );
        if (hasCMR.length > 0) {
          this.$showAlert(
            'error',
            'Container Assigned to CMR',
            'One or more selected container has already assigned to a CMR.<br>Please select containers that has no CMR.',
          );
          return;
        }

        // this.containerList = [];
        // await this.$nextTick();

        addedContainerList = JSON.parse(JSON.stringify(this.selectedJobContainer));
        // this.containerList = JSON.parse(JSON.stringify(this.selectedJobContainer));
      } else if (text.includes('Select All')) {
        const selected = this.jobContainerList.filter((c) => (c['CMR #'] ? !c['CMR #'].trim() : true));
        this.containerList = [];
        await this.$nextTick();
        addedContainerList = JSON.parse(JSON.stringify(selected));
        this.containerList = JSON.parse(JSON.stringify(selected));
      }

      const containerListTemp = JSON.parse(JSON.stringify(this.containerList));
      this.containerList = [];
      await this.$nextTick();

      addedContainerList.forEach((a) => {
        if (containerListTemp.filter((b) => b['Container #'] == a['Container #']).length < 1) {
          containerListTemp.push({
            '#': containerListTemp.length == 0 ? '1' : containerListTemp.length + 1,
            'Container #': a['Container #'],
            'CMR #': a['CMR #'],
            'Job Type': a['Job Type'],
            'Seal No': a['Seal No'],
            Size: a['Size'],
            Type: a['Type'],
            Handling: a['Handling'],
            Delivery: a['Delivery'],
            'Haul. Tariff': '0.00',
            Toll: '0.00',
            FAF: '0.00',
            Total: '0.00',
            tag: '1',
          });
        } else {
          const index = containerListTemp.findIndex((deleted) => {
            //revert back tag 5(delete) to 2(edit)
            return deleted['Container #'] == a['Container #'] && deleted['tag'] == '5';
          });

          containerListTemp[index]['tag'] = '2';
        }
      });
      this.containerList = JSON.parse(JSON.stringify(containerListTemp));
      this.selectedJobContainer = [];
      await this.$nextTick();
      this.showJobContainers = false;
    },
    filterJobContWithoutCMR: async function () {
      let filtered = [];
      if (this.showJobContWithoutCMR) {
        // filtered = this.jobContainerList.filter(c => c['CMR #'] ? !c['CMR #'].trim() : true);
        filtered = this.filteredJobContainerList.filter((c) => (c['CMR #'] ? !c['CMR #'].trim() : true));
      } else {
        filtered = this.filteredJobContainerList;
      }

      this.filteredJobContainerList = [];
      await this.$nextTick();
      this.filteredJobContainerList = filtered;
      await this.$nextTick();
      // this.selectedJobContainer = JSON.parse(JSON.stringify(this.containerList))
    },
    //#endregion

    //#region Attachments Tab Methods
    attachmentFileChanged: function (files) {
      this.selectedFiles = files;
    },
    addAttachmentClicked: async function () {
      if (this.selectedFiles.length > 0) {
        const attachmentToAdd = [];
        let count = 1;
        for (const f of Array.from(this.selectedFiles)) {
          attachmentToAdd.push({
            'File Name': `${f['name'].trim()} *`,
            'Date Added': new Date().formatString('yyyy-MM-dd'),
            Remarks: this.attachRemarks,
            'File Type': f['type'],
            'File Data': await this.$convertFile.toBase64(f),
            DocumentGUID: `TEMPORARY-GUID-${count++}`, // post increment
          });
        }

        const temp = this.attachmentList;
        this.attachmentList = [];
        this.$nextTick(() => {
          this.attachmentList = temp.concat(attachmentToAdd);
          this.$refs['attachmentFileInput'].clearAttachmentClicked();
          this.attachRemarks = '';
        });
      } else {
        this.$showAlert('error', 'No File Selected', 'Please select at least 1 file to add to the attachment list.');
      }
    },
    selectDocumentFromJob: async function () {
      this.showJobDocuments = true;
      this.jobDocumentsLoading = true;
      const documents = this.$jsonNullToStringV2(
        this.$deepTrimJsonV3(await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${this.JobNo}`)),
      );
      this.jobDocumentsList = documents
        .map((d) => {
          if (d['AttImage'] && d['AttImageType'] && d['Doc Code'].trim() != 'ECMR' && d['Doc Code'] != 'eROT') {
            return {
              'Doc Code': d['Doc Code'],
              'Doc Ref #': d['Reference No'],
              Attachment: d['AttImageName'],
              Remarks: d['Remarks'],
              Status: d['Status Count'] > 0 ? d['Status Code'] : 'N/A',
              'Start Date': d['Status Count'] > 0 ? d['Start DateTime'] : 'N/A',
              'Received Date': d['Status Count'] > 0 ? d['Received DateTime'] : 'N/A',
              'Due Date': d['Status Count'] > 0 ? d['Due DateTime'] : 'N/A',
              'Assign To': d['Status Count'] > 0 ? d['Assign To'] : 'N/A',
              Sets: d['Status Count'] > 0 ? d['Sets'] : 'N/A',
              Page: d['Status Count'] > 0 ? d['Pages'] : 'N/A',

              documentGUID: d['DocumentGUID'],
              ID: `${d['Doc Code']}-${d['Reference No']}`,
              fileAtt: d['AttImage'],
              filetype: d['AttImageType'],
            };
          }
        })
        .filter((d) => d);
      this.jobDocumentsLoading = false;
    },
    jobDocumentsButtonClicked: function (text) {
      if (text.includes('Confirm')) {
        const temp = this.attachmentList;
        this.attachmentList = [];

        const toAdd = this.selectedJobDocuments.map((d) => {
          return {
            'File Name': d['Attachment'] ? `${d['Attachment']} *` : 'NoFileName',
            'Date Added': new Date().formatString('yyyy-MM-dd'),
            Remarks: d['Remarks'],
            'File Type': d['filetype'],
            'File Data': d['fileAtt'],
            DocumentGUID: d['documentGUID'],
          };
        });
        this.$nextTick(() => (this.attachmentList = temp.concat(toAdd)));
      }
      this.jobDocumentsList = [];
      this.selectedJobDocuments = [];
      this.showJobDocuments = false;
    },
    removeAttachmentClicked: async function () {
      if (this.selectedAttachments.length == 0) {
        this.$showAlert('error', 'No Attachment Selected', 'Please select at least 1 attachment to delete.');
      } else {
        const confirmDelete = await this.$showAlert(
          'warning',
          'Delete Attachments',
          `Do you confirm you want to delete ${this.selectedAttachments.length} attachments?`,
          [
            { text: 'Delete', color: 'red', textColor: 'white' },
            { text: 'Cancel', color: 'gray', textColor: 'white' },
          ],
        );

        if (confirmDelete == 'Delete') {
          this.selectedAttachments.forEach((s) => {
            const index = this.attachmentList.indexOf(s);
            this.attachmentList.splice(index, 1);
          });

          const temp = this.attachmentList;
          this.attachmentList = [];
          this.$nextTick(() => (this.attachmentList = temp));

          this.selectedAttachments = [];
        }
      }
    },
    //#endregion

    //#region Delete ROT Methods
    confirmDeleteROTButtonClicked: function (text) {
      if (!this.deleteReason && text == 'Delete') {
        this.$showAlert('error', 'No Reason Specified', 'Please specify your reason of ROT cancellation.');
        return;
      }

      this.showDeleteReason = false;
      if (this.deleteResolve) {
        this.deleteResolve(text == 'Delete');
      }
    },
    //#endregion

    populateContainerList: async function () {
      const tempContainerList = await this.$apiCallV2(`/ROT/GetRotCont?jobno=${this.JobNo}&showall=1`);
      if (tempContainerList.length > 0) {
        tempContainerList.forEach((c) => {
          c['tag'] = '1';
          if (c['CMR #']) {
            c['tag'] = '4';
          }
          if (this.containerList.length > 0) {
            if (
              this.containerList
                .map((a) => {
                  return a['Container #'];
                })
                .includes(c['Container #'])
            ) {
              c['tag'] = '2';
            }
          }
        });
      }

      this.jobContainerList = JSON.parse(JSON.stringify(tempContainerList));
      this.filteredJobContainerList = JSON.parse(JSON.stringify(tempContainerList));
    },

    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },

    verifyROT: async function (jobno) {
      // if cargo type != 'FC%', dont allow to edit
      this.$fullscreenLoading('Verifying');
      const validate = await this.$apiCallV2(`/ROT/ValidateJobsForROT?jobno=${jobno}`);
      this.$fullscreenLoading();
      if (validate[0]['Results'] == 1) {
        await this.$showAlert('error', `Unable to edit ROT ${this.rotFullData['CMR No']}`, validate[0]['ErrMsg']);
        return true;
      }
      return false;
    },

    openFromParams() {
      const params = new URLSearchParams(window.location.search);

      const newValue = params.get('New');
      if (newValue != null) this.menuClicked({ title: 'New ROT' });
    },
  },
  async mounted() {
    this.startDate = new Date();
    this.endDate = new Date();
    this.jobStartDate = new Date();
    this.jobEndDate = new Date();
    await this.refreshClicked();

    const mountedPromises = [];
    let promisesFulfilled = 0;

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'JOBQUERY', module: 'CON' }).then((result) => {
        this.searchFilterItems = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'haulier' }).then((result) => {
        this.haulierList = this.$deepTrimJsonV3(result).map((haulier) => ({
          ...haulier,
          'Code - Description': `${haulier['Haulier Code']} - ${haulier['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'employee_rot' }).then((result) => {
        this.requestedByList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'pickup' }).then((result) => {
        this.pickupList = this.$deepTrimJsonV3(result).map((pickup) => ({
          ...pickup,
          'Code - Company': `${pickup['Destination Code']} - ${pickup['Company']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'dropoff' }).then((result) => {
        this.dropoffList = this.$deepTrimJsonV3(result).map((dropoff) => ({
          ...dropoff,
          'Code - Company': `${dropoff['Destination Code']} - ${dropoff['Company']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'trip_rot' }).then((result) => {
        this.tripList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'sendto_all' }).then((result) => {
        this.allSendToList = this.$deepTrimJsonV3(result).map((sendto) => ({
          ...sendto,
          'Code - Company': `${sendto['Destination Code']} - ${sendto['Company']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contsize' }).then((result) => {
        this.contSizeList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conttype' }).then((result) => {
        this.contTypeList = this.$deepTrimJsonV3(result);
        this.contTypeList.forEach((c) => (c['combined'] = `${c['Description']} (${c['Cont Type']})`));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'conthandlingtype' }).then((result) => {
        this.contHdgList = this.$deepTrimJsonV3(result);
        this.contHdgList.forEach((c) => (c['combined'] = `${c['Description']} (${c['Handling Type']})`));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contdeliverytype' }).then((result) => {
        this.contDeliveryList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    this.contDeliveryList.forEach((c) => (c['combined'] = `${c['Description']} (${c['Delivery Type']})`));

    await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menuItems = this.menuItems.map((menuItem) => ({
        ...menuItem,
        enabled: true,
      }));
    });

    if (this.$route.query['jobNo']) {
      //to filter all ROT related to the jobno
      this.JobNo = this.$route.query['jobNo'];
      this.dateFilterChecked = false;
      this.searchFilterChecked = true;
      this.selectedSearchBy = this.searchFilterItems.find((obj) => obj['Search Criteria'] == 'Job #');
      this.selectedCriteria = this.searchCriteriaItems.find((obj) => obj['name'] == 'CONTAINS');
      this.searchByValue = this.$route.query['jobNo'];
      this.refreshClicked();
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }

    this.openFromParams();
  },
  watch: {
    popupEntryShow: function (val) {
      if (!val) {
        this.jobNoInput = '';
        this.jobNoInputError = '';
        this.popupEntryMessages = [];
        this.popupEntryErrorMessage = [];
        this.popupEntrySuccessMessage = [];
        this.popupEntryRequiredError = [];

        this.jobDetails = null;

        this.currentTabIndex = 0;

        //#region Top Section Data
        this.rotNo = '';
        this.JobNo = '';
        this.jobType = '';
        this.rotDateTime = null;
        this.isUrgent = false;
        this.customerCode = '';
        this.customerName = '';
        this.selectedHaulBillTo = null;

        this.selectedHaulier = null;
        this.rotHaulierError = '';
        this.haulRqtNo = '';
        this.haulAcceptTime = '';
        // this.requestedBy = '';
        this.RequestedByValue = '';
        this.selectedRequestedBy = null;
        this.rotRequestByError = '';
        this.rqtAcceptedBy = '';

        this.rotIndicator = '';
        this.rotPrintCount = '0';
        //#endregion

        //#region Location Info Tab
        this.selectedPickup = null;
        this.rotPickupError = '';
        this.sendToList = [];
        this.selectedSendTo = null;
        this.rotSendToError = '';
        this.showAllSendTo = false;
        this.tariffArea = '';
        this.postcode = '';
        this.zone = '';
        this.attention = '';
        this.telNo = '';
        this.address = '';

        this.selectedDropoff = null;
        this.rotDropoffError = '';
        this.selectedTrip = null;
        this.rotTripError = '';

        this.requiredDateTime = null;
        this.toDateTime = null;
        this.desc = '';
        this.isOfficeHours = false;
        this.abilityAcceptCont = '';
        this.timeStuffUnstuff = '';
        this.isOffloadAtPremises = false;
        //#endregion

        //#region Container Info Tab
        this.isSelectFromList = true;
        this.isRequestByTotalContainers = false;
        this.showJobContainers = false;
        this.jobContainerList = [];
        this.selectedJobContainer = [];
        this.containerList = [];
        this.selectedContainer = [];

        this.containerCount = '';
        this.containerCountError = '';
        this.selectedConSize = null;
        this.selectedConSizeError = '';
        this.selectedContType = null;
        this.selectedContTypeError = '';
        this.selectedHdg = null;
        this.selectedHdgError = '';
        this.selectedDelivery = null;
        this.selectedDeliveryError = '';

        this.temperature = '';
        this.m3 = '';
        this.weight = '';
        this.height = '';
        this.contOperator = '';
        this.contLine = '';
        this.commodity = '';
        this.rotCommodityError = '';
        this.isFumigation = false;
        this.remarks = '';
        //#endregion

        //#region Attachments Tab
        this.selectedFiles = [];
        this.attachRemarks = '';
        this.showJobDocuments = false;
        this.jobDocumentsList = [];
        this.selectedJobDocuments = [];
        this.jobDocumentsLoading = false;
        this.attachmentList = [];
        this.selectedAttachments = [];
        //#endregion
      } else {
        this.refreshJobListClicked();
      }
    },
    showAllSendTo: function (val) {
      this.sendToList = val ? this.allSendToList : this.custSendToList;
      this.selectedSendTo = null;
    },
    selectedSendTo: function (val) {
      if (val) {
        this.tariffArea = val['Tariff Area'];
        this.postcode = val['PostCode'];
        this.zone = val['Zone'];
        this.attention = val['Attn'];
        this.telNo = val['Phone'];
        const addList = [
          // val['Company'],
          val['Addr1'],
          val['Addr2'],
          val['Addr3'],
          val['Addr4'],
          // `${val['PostCode']}, ${val['City']}`,
          // `${val['State']}, ${val['Country']}`
        ];
        this.address = addList.filter((a) => a).join('\n');
      } else {
        this.tariffArea = '';
        this.postcode = '';
        this.zone = '';
        this.attention = '';
        this.telNo = '';
        this.address = '';
      }
    },
    jobList(newList) {
      if (newList.length > 0) {
        this.setFocusOnJobNo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.rot-page-main {
  font-size: 12px;
  padding: 10px 45px;
  display: flex;
  position: relative;

  > .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;

    > .filter-area {
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > * {
        margin-left: 5px;
      }

      > .filter-button {
        position: relative;

        > .filter-box {
          position: absolute;
          right: 0;
          top: 100%;
          border: 1px solid black;
          border-radius: 3px;
          padding: 5px;
          background-color: white;
          display: flex;
          flex-direction: column;
          z-index: 99;

          > .filter-item {
            border: 1px solid black;
            border-radius: 5px;
            padding: 5px;
            padding-top: 10px;
            margin: 5px;
            margin-top: 10px;
            position: relative;

            > .filter-check {
              position: absolute;
              top: -10px;
              background-color: white;
              padding: 0 10px;
              left: 10px;
            }

            > .dates {
              display: flex;

              > * {
                margin: 0 3px;
              }
            }
          }

          > button {
            position: relative;
            right: 5px;
            align-self: flex-end;
          }
        }
      }
    }

    > .tabulator-area {
      background-color: white;
      margin-top: 5px;
      border-radius: 5px;
      height: calc(100% - 43px);
      padding: 5px;
    }
  }

  > .print-popup {
    position: absolute;
    background: rgba(128, 128, 128, 0.5);
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    padding: 30px 65px;
    display: flex;
    flex-direction: column;

    > .title {
      background-color: rgb(50, 54, 57);
      color: white;
      text-align: center;
      font-weight: bold;
      padding: 5px;
    }
  }
}

.select-job-main {
  height: 100%;

  > .job-no-section,
  > .job-refresh-section {
    display: flex;
    align-items: center;

    > :not(:first-child) {
      margin-left: 5px;
    }
  }

  > .job-refresh-section {
    justify-content: flex-end;
    margin: 5px 0;
  }

  > .job-list-table {
    height: calc(100% - 68px);
  }
}

.new-rot-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  > .top-section {
    width: 100%;
    display: flex;

    > :not(:last-child) {
      width: 100%;
    }

    > :last-child {
      min-width: 60px;
      max-width: 60px;
      display: flex;
      flex-direction: column;

      > :nth-child(1) {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 1.5em;
      }

      > :not(:nth-child(2)) {
        padding: 5px;
        border: 1px solid lightgray;
        border-radius: 5px;
        min-height: 30px;

        > img {
          width: 100%;
          height: 50%;
          object-fit: contain;
        }
      }

      :nth-child(2) {
        height: 100%;
      }
    }

    > :not(:first-child) {
      margin-left: 5px;
    }
  }

  > .tab-section {
    height: calc(100% - 175px);
    margin-top: 5px;

    > :nth-child(1) {
      height: 100%;
    }
  }
}

.flex-row {
  display: flex;

  > :not(:first-child) {
    margin-left: 5px;
  }
}

.tab-slot {
  width: 100%;
  height: 40%;
  > * {
    width: 100%;
  }
}

.box-container {
  display: flex;
  align-items: center;
  justify-content: center;

  > button {
    width: fit-content;
  }
}

.remarks-container {
  display: flex;
  height: 100%;
  position: relative;
}

.remarks-box-container {
  flex-grow: 1;
  padding-right: 40px;
}

.remarks-container button {
  position: absolute;
  top: 20px;
  right: 5px;
}
</style>
